class Storage{
    get(key){
        var temp = window.localStorage.getItem(key);
        var res = {};
        if(temp &&  ~temp.indexOf("{")){
             res = temp && JSON.parse(temp);
        }else if(temp){
            res = temp;
        }
        return res;
    }
    set(key, value){
        if(value instanceof Object){
            value = JSON.stringify(value);
        }
        return window.localStorage.setItem(key, value);
    }
}

export default Storage;



// WEBPACK FOOTER //
// ./src/utils/Storage.js